class PehchaanReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;
    this.cards = Array.from(this.track.children);
    this.prevBtn = this.querySelector('.pch-reviews__nav--prev');
    this.nextBtn = this.querySelector('.pch-reviews__nav--next');

    var dotsWrap = this.closest('.pch-reviews') ? this.closest('.pch-reviews').querySelector('[data-dots]') : null;
    this.dots = dotsWrap ? Array.from(dotsWrap.children) : [];

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', this.scrollPrev.bind(this));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', this.scrollNext.bind(this));
    }
    this.dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        this.scrollToCard(index);
      }.bind(this));
    }, this);

    this.onScroll = this.updateActiveDot.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.updateNavVisibility();
    this.updateActiveDot();

    window.addEventListener('resize', this.updateNavVisibility.bind(this));
  }

  cardStep() {
    var card = this.cards[0];
    var rect = card.getBoundingClientRect();
    var styles = getComputedStyle(this.track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return rect.width + gap;
  }

  scrollPrev() {
    this.track.scrollBy({ left: -this.cardStep(), behavior: 'smooth' });
  }

  scrollNext() {
    this.track.scrollBy({ left: this.cardStep(), behavior: 'smooth' });
  }

  scrollToCard(index) {
    var card = this.cards[index];
    if (!card) return;
    this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
  }

  updateActiveDot() {
    if (!this.dots.length) return;
    var atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    var closestIndex;
    if (atEnd) {
      closestIndex = this.cards.length - 1;
    } else {
      var trackLeft = this.track.getBoundingClientRect().left;
      var closestDist = Infinity;
      closestIndex = 0;
      this.cards.forEach(function (card, index) {
        var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = index;
        }
      });
    }
    this.dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === closestIndex);
    });
  }

  updateNavVisibility() {
    if (!this.prevBtn || !this.nextBtn) return;
    var isScrollable = this.track.scrollWidth > this.track.clientWidth + 4;
    this.prevBtn.hidden = !isScrollable;
    this.nextBtn.hidden = !isScrollable;
  }
}

customElements.define('pehchaan-reviews-carousel', PehchaanReviewsCarousel);
